module.exports = __webpack_public_path__ + "static/media/btn2.a8fba940.svg";